module.exports = __webpack_public_path__ + "static/img/add-s.9f6479a.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/add-s.png
// module id = D6RU
// module chunks = 0